/**
 * Zeitvorschläge (v1.404.0) — Regeln, die die Oberfläche zum Anzeigen braucht. Entschieden wird im
 * Server (services/timeProposals/proposalRules.ts); hier steht nur, was der Knopf sagen soll.
 * Beide ändern, wenn sich die Regel ändert.
 */

/** Direkt für andere buchen: Admin und Teamlead. Alle anderen schicken einen Vorschlag. */
export function mayBookForOthers(role: string | null | undefined): boolean {
  return role === 'ADMIN' || role === 'TEAMLEAD';
}

/** Mindestlänge des Grunds beim Verwerfen (Server: REJECT_REASON_MIN_LENGTH). */
export const REJECT_REASON_MIN_LENGTH = 5;

/** „1:30 h" */
export function formatProposalMinutes(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}:${String(m).padStart(2, '0')} h`;
}

/** „Do., 29.10., 08:00" in Berlin, ohne Uhrzeit, wenn keine angegeben ist. */
export function formatProposalStart(iso: string | null, withTime = true): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  return d.toLocaleString('de-DE', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
    timeZone: 'Europe/Berlin',
  });
}

/** Hinweis unter „Buchung als", wenn ein Techniker einen Kollegen wählt. */
export function proposalHint(recipientName: string): string {
  return (
    `Du buchst nicht selbst für ${recipientName}: Es geht ein Zeitvorschlag raus, ${recipientName} ` +
    'bekommt eine Push-Nachricht und gibt ihn frei (dann unter eigenem Namen gebucht) oder verwirft ihn.'
  );
}
